<template>
  <div>
    <table-manager @filterChanged="filterChanged"  @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>
    <basic-table
      v-if="ipZoneList"
      :items="ipZoneList"
      :fields="ipZoneFields"
      :filter="filter"
      @ClickOnEditButton="editItem"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
    <editModal :editItem="currentRowIpZone"/>
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  components: {
    editModal
  },
  data () {
    return {
      currentRowIpZone: null,
      isShowAddIpZone: false,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      ipZoneFields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Name'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ]
    }
  },
  methods: {
    showAdd () {
      this.currentRowIpZone = {
        id: 0,
        name: '',
        networks: []
      }
      this.$root.$emit('bv::show::modal', 'modalEditIPzones', '#btnShow')
    },
    editItem (item) {
      this.currentRowIpZone = JSON.parse(JSON.stringify(item))
      this.$root.$emit('bv::show::modal', 'modalEditIPzones', '#btnShow')
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    ipZoneList () {
      return this.$store.getters['ReferenceBooks/IP_ZONES']
    }
  },
  mounted () {
    this.$store.dispatch('ReferenceBooks/GET_IP_ZONES')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/referenceBook/IPzone/main.vue